<div *ngFor="let panel of panelsRef" [hidden]="!isPanelActive(panel)">
    <ng-container [ngTemplateOutlet]="panel"></ng-container>
</div>